import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class FeedbackQuestionService {
    public backClicked: EventEmitter<any> = new EventEmitter();

    public answeredAnswers: any[] = [];

    public addAnswerToAnsweredAnswers(answer:any) {
        // avoid duplicate user answers by removing already answered questions answers
        this.answeredAnswers = this.answeredAnswers.filter(function( obj ) {
            return obj.question.id !== answer.question.id;
        });

        this.answeredAnswers.push(answer);
    }

    public getAnsweredAnswers() {
        return this.answeredAnswers;
    }

    public getAnsweredAnswersByQuestionId(id: number) {
        return this.answeredAnswers.find((obj) => obj.question.id === id);
    }

    public reset() {
        this.answeredAnswers = [];
    }
}
